import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import './styles.css'
import dane from './../../../../static/images/dane.svg'
import firemniporadenstvi from './../../../../static/images/firemniporadenstvi.svg'
import mzdy from './../../../../static/images/mzdy.svg'
import ucetnictvi from './../../../../static/images/ucetnictvi.svg'
import Image from './../../Default/Image'
import Img from 'gatsby-image'
const HomepageLanding = ({ photo }) => (
  <div className="LandingPhoto">
    <div className="row align-items-center">
      <div className="col-xl-6 col-lg-12">
        <Img fluid={photo.fluid} alt="Homepage photo" />
      </div>
      <div className="col-xl-5 offset-xl-1 col-lg-12">
        <div className="container row justify-content-center">
          <div className="h1-mobile col-12">
            <h1>EK Partners, s.r.o.</h1>
            <h2>daňoví a účetní poradci</h2>
          </div>
          <div className="col-xl-6 col-lg-3 col-sm-6 col-12">
            <div className="LandingPhoto--Wrap LandingPhoto--WrapXL--Right">
              <img src={dane} alt="Daně" />
              <h2>Daně</h2>
            </div>
          </div>
          <div className="col-xl-6 col-lg-3 col-sm-6 col-12">
            <div className="LandingPhoto--Wrap LandingPhoto--WrapXL--Left">
              <img src={ucetnictvi} alt="Účetnictví" />
              <h2>Účetnictví</h2>
            </div>
          </div>
          <div className="col-xl-6 col-lg-3 col-sm-6 col-12">
            <div className="LandingPhoto--Wrap LandingPhoto--WrapXL--Right">
              <img src={firemniporadenstvi} alt="Firemní poradenství" />
              <h2>Firemní poradenství</h2>
            </div>
          </div>
          <div className="col-xl-6 col-lg-3 col-sm-6 col-12">
            <div className="LandingPhoto--Wrap LandingPhoto--WrapXL--Left">
              <img src={mzdy} alt="Mzdy" />
              <h2>Mzdy</h2>
            </div>
          </div>
          <div className="h1-desktop col-12">
            <h1>EK Partners, s.r.o.</h1>
            <h2>daňoví a účetní poradci</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
)

const HomepageLandingData = () => {
  const { homepageLanding } = useStaticQuery(graphql`
    query {
      homepageLanding: file(relativePath: { eq: "homepage-landing.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return <HomepageLanding photo={homepageLanding.childImageSharp} />
}

export default HomepageLandingData
